<template>
  <div class="x-flex x-rela  " style="background-color: #fff;padding: 5px 10px;">
    <div class="bgc-f x-w30  x-flex x-row-center x-m-r-4 x-cur-poi x-bd-ra-4" @click="scrollLeft"
      style="border: 1px solid #c4cdd5;height: 100%;">
      <i class="el-icon-arrow-left x-p-l-10  x-p-r-10"></i>
    </div>
    <div class="tabs-container  x-flex-1 " v-horizontal-scroll ref="tabsContainer">
      <div class="tag x-flex  x-bd-ra-4" size="medium" :closable="index > 0" v-for="(item, index) in tagsData"
        :key="item.path" @mouseenter="hoverIndex = index" @click="goPath(item.path)" @close="close(index)"
        :class="item.title == $route.meta.title ? 'act-tag' : ''">
        <!-- <div class="x-m-r-10"> -->
        <!-- <img @click="refresh(item.path)" v-if="item.title == $route.meta.title" src="@/assets/img/vip/Refresh-1.png"
          alt="" style="width: 14px;height: 14px;margin-right: 5px;cursor: pointer;">
        <img @click="refresh(item.path)" v-else src="@/assets/img/vip/Refresh.png" alt=""
          style="width: 14px;height: 14px;margin-right: 5px;cursor: pointer;"> -->
        <!-- </div> -->
        <!-- <div class="cir"></div> -->
        <i class="el-icon-refresh-right x-p-r-5" @click="refresh(item.path)"></i>
        {{ item.title }}
        <i class="el-icon-close" @click="close(index)" v-if="index > 0"></i>
      </div>
      <!-- <el-tabs v-model="editableTabsValue" type="card"  @tab-remove="removeTab">
      <el-tab-pane
        v-for="(item, index) in tagsData"
        :key="item.name"
        :label="item.title"
        :name="item.name"
        :closable="index > 0">
        {{item.content}}
      </el-tab-pane>
    </el-tabs> -->
    </div>
    <div class="bgc-f x-w30  x-flex x-row-center x-m-l-5 x-m-r-4 x-cur-poi x-bd-ra-4" @click="scrollRight"
      style="border: 1px solid #c4cdd5;height: 100%;  ">
      <i class="el-icon-arrow-right  "></i>
    </div>
    <div class="bgc-f  x-flex x-row-center  x-cur-poi x-bd-ra-4" style="height: 100%;border: 1px solid #c4cdd5;">
      <!-- <i class="el-icon-arrow-down x-p-l-10 x-p-r-10 x-cur-poi" @click="rightClick($event, selectedTabIndex)"></i> -->
      <TagsMenuVue v-show="true" :clientX="clientX" :clientY="clientY" :clickIndex="clickIndex"
        :tagsLength="tagsData.length" @fn="clickMenu" />
    </div>


  </div>
</template>

<script>
  import TagsMenuVue from "./TagsMenu.vue";
  /**
   * 标签页管理组件
   * 功能说明：
   * 1. 根据saas_type_id动态设置默认导航标签
   *    - 当saas_type_id === 'sipLs'时，默认显示"零售导航"(/lsNav)
   *    - 其他情况下，默认显示"菜品导航"(/cpNav)
   * 2. 支持标签页的添加、切换、关闭等操作
   * 3. 提供批量关闭标签功能，始终保留默认导航
   */
  export default {
    components: {
      TagsMenuVue,
    },
    directives: {
      "horizontal-scroll": {
        bind: function(el) {
          el.addEventListener("wheel", function(event) {
            event.preventDefault();
            el.scrollLeft += event.deltaY;
          });
        },
      },
    },
    data() {
        // 获取默认导航：根据saas_type_id判断是零售导航还是菜品导航
        const defaultNav = this.$store.state.djsAdmin.saas_type_id === 'sipLs'
          ? { title: "零售导航", path: "/lsNav" }
          : { title: "菜品导航", path: "/cpNav" };
        
        return {
          tagsData: [defaultNav],
        isShowTagsMenu: false,
        clientX: 0,
        clientY: 0,
        clickIndex: 0,
        hoverIndex: 0,
        editableTabsValue: "home",
      };
    },
    computed: {
      activeTabIndex() {
        return this.tagsData.findIndex(item => item.path === this.$route.path);
      },
      // selectedTabIndex() {
      //   this.clickIndex = this.tagsData.findIndex(item => item.title === this.$route.meta.title);
      //   // 根据 $route.meta.title 获取选中的 tabs 索引
      //   return this.clickIndex
      // }
    },
    watch: {
      clickIndex(e) {},
      $route: {
        immediate: true,
        handler(val) {
          const bool = this.tagsData.find((item, index) => val.path == item.path);


          if (!bool) {
            this.tagsData.push({
              title: val.meta.title,
              path: val.path,
            });
            this.clickIndex = this.tagsData.findIndex(item => item.title === val.meta.title);
          }

          this.$nextTick(() => {
            const container = this.$refs.tabsContainer;
            const activeTab = container.querySelector('.act-tag'); // 找到当前激活的 tab

            if (activeTab) {
              activeTab.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
              }); // 使用 scrollIntoView 实现平滑滚动
            }
          });
        },
      },
    },

    mounted() {
      // 给文档新增点击事件
      document.addEventListener("click", this.closeMenus);
    },
    methods: {
      init() {
        // 页面初始化逻辑
      },
      refresh(path) {
        if (path === this.$route.path) {
          console.log(path);
          this.$emit('refresh-page', path);
        } else {
          this.$router.push(path);
          this.$nextTick(() => {
            this.$emit('refresh-page', path);
          });
        }
      },
      scrollLeft() {
        const container = this.$refs.tabsContainer;
        container.scrollLeft -= 100; // 每次向左滚动100px
      },
      scrollRight() {
        const container = this.$refs.tabsContainer;
        container.scrollLeft += 100; // 每次向右滚动100px
      },
      // 点击标签跳转
      goPath(path) {
        // 解决重复点击会报错，数据冗余
        if (path !== this.$route.path) {
          this.$router.push(path);
        }
        this.clickIndex = this.tagsData.findIndex(item => item.path === path);
        this.closeMenus();
      },
      // 关闭选择菜单
      closeMenus() {
        this.isShowTagsMenu = false;
      },
      /**
       * 点击标签菜单操作
       * @param {number} i 菜单项索引
       */
      clickMenu(i) {
        // 开发环境下添加调试日志
        if (process.env.NODE_ENV === 'development') {
          console.log('tabs.vue - clickMenu called with i=' + i);
          console.log('Current route:', this.$route.path);
        }
        // 关闭其他，就保留自己的包含默认导航
        if (i === 0) {
          // 获取默认导航：根据saas_type_id判断是零售导航还是菜品导航
          const defaultNav = this.$store.state.djsAdmin.saas_type_id === 'sipLs'
            ? { title: "零售导航", path: "/lsNav" }
            : { title: "菜品导航", path: "/cpNav" };
            
          // 获取要保留的标签
          const currentItem = this.tagsData[this.clickIndex];
          
          // 确定目标激活路径
          const activePath = currentItem.path === defaultNav.path ? defaultNav.path : currentItem.path;
          
          // 先跳转路由，路由成功后再修改标签列表
          if (activePath !== this.$route.path) {
            // 添加路由变化监听器，在路由真正改变后修改标签列表
            const unwatch = this.$router.afterEach((to, from) => {
              if (to.path === activePath) {
                // 路由跳转成功，现在修改标签列表
                if (currentItem.path === defaultNav.path) {
                  this.tagsData = [defaultNav];
                } else {
                  this.tagsData = [defaultNav, currentItem];
                }
                unwatch(); // 移除监听器，防止重复调用
              }
            });
            
            this.goPath(activePath);
          } else {
            // 已经在目标路由上，直接修改标签列表
            if (currentItem.path === defaultNav.path) {
              this.tagsData = [defaultNav];
            } else {
              this.tagsData = [defaultNav, currentItem];
            }
          }
        }
        else if (i === 1) {
          // 全部关闭
          // 根据全局 saas_type_id 判断是默认菜品导航还是零售导航
          const defaultNav = this.$store.state.djsAdmin.saas_type_id === 'sipLs'
            ? { title: "零售导航", path: "/lsNav" }
            : { title: "菜品导航", path: "/cpNav" };

          // 先跳转到默认导航，成功后再清空标签列表
          if (defaultNav.path !== this.$route.path) {
            // 添加路由变化监听器，在路由真正改变后修改标签列表
            const unwatch = this.$router.afterEach((to, from) => {
              if (to.path === defaultNav.path) {
                // 路由跳转成功，现在修改标签列表
                this.tagsData = [defaultNav];
                unwatch(); // 移除监听器，防止重复调用
              }
            });
            
            this.goPath(defaultNav.path);
          } else {
            // 已经在默认导航上，直接修改标签列表
            this.tagsData = [defaultNav];
          }
        } else if (i === 2) { // 关闭当前页签
          // 直接调用close方法，它已经包含了正确的处理逻辑
          const currentIndex = this.clickIndex;
          this.close(currentIndex);
        }
      },
      /**
       * 获取当前路由对应的组件实例
       * @returns {VueComponent|null} 组件实例或null
       */
      fGetCurrentComponentInstance() {
        let app = this.$root;
        while (app && !app.$options.name) {
          app = app.$children[0];
        }
        if (app && app.$children) {
          for (let child of app.$children) {
            if (child.$options.name === 'AppMain') {
              return child.$children[0];
            }
          }
        }
        return null;
      },
      
      /**
       * 检查当前页面是否有未保存的数据变更
       * @returns {boolean} 是否有未保存变更
       */
      fCheckDataChanged() {
        const component = this.fGetCurrentComponentInstance();
        if (!component) return false;
        
        // 检查多种可能的数据变更标志
        if (component.isDataChanged) return true;
        if (component.hasDataChanged) return true;
        if (typeof component.fCheckDataChanged === 'function' && component.fCheckDataChanged()) return true;
        
        return false;
      },
      
      /**
       * 关闭标签页
       * @param {number} i 标签索引
       */
      /**
       * 执行标签关闭操作
       * @param {number} i 标签索引
       */
      fPerformTabClose(i) {
        this.tagsData.splice(i, 1);
      },
      
      /**
       * 关闭标签页
       * @param {number} i 标签索引
       */
      close(i) {
        const tagToClose = this.tagsData[i];
        const isCurrentTag = tagToClose.path === this.$route.path;
        
        // 获取目标路由
        let targetPath = null;
        if (isCurrentTag) {
          if (i !== this.tagsData.length - 1) {
            targetPath = this.tagsData[this.tagsData.length - 1].path;
          } else if (i > 0) {
            targetPath = this.tagsData[this.tagsData.length - 2].path;
          }
        }
        
        // 不是当前标签，直接删除
        if (!isCurrentTag) {
          this.fPerformTabClose(i);
          this.closeMenus();
          return;
        }
        
        // 是当前标签且需要跳转
        if (targetPath) {
          // 检查当前页面是否有未保存数据
          const hasUnsavedChanges = this.fCheckDataChanged();
          
          // 定义路由跳转成功后的回调函数
          const onRouteChangeSuccess = () => {
            // 重新获取标签索引
            const updatedIndex = this.tagsData.findIndex(tag => tag.path === tagToClose.path);
            if (updatedIndex !== -1) {
              this.fPerformTabClose(updatedIndex);
            }
          };
          
          // 添加路由变化监听器，在路由真正改变后删除标签
          const unwatch = this.$router.afterEach((to, from) => {
            if (to.path !== from.path) {
              onRouteChangeSuccess();
              unwatch(); // 移除监听器，防止重复调用
            }
          });
          
          // 执行路由跳转
          this.$router.push(targetPath);
          
          // 预先设置clickIndex
          this.clickIndex = this.tagsData.findIndex(item => item.path === targetPath);
        }
        
        this.closeMenus();
      },
      // 右键点击
      rightClick(e, i) {
        this.isShowTagsMenu = true;
        this.clientX = e.clientX;
        this.clientY = e.clientY;
        this.clickIndex = i;

      },
    },
  };
</script>
<style lang="scss" scoped>
  .tabs-container {
    width: 100%;
    height: 100%;

    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    display: flex;
    scroll-behavior: smooth; // 新增：新增平滑滚动效果
  }

  .tag {
    cursor: pointer;
    margin-right: 5px;
    height: 100%;
    line-height: 34px;
    font-size: 14px;
    transition: all 0.3s ease-in-out;
    border: 1px solid #c4cdd5;

    .cir {
      width: 8px;
      height: 8px;
      margin-right: 4px;
      background-color: #808080;
      border-radius: 50%;
      display: inline-block;
    }
  }

  .tag {
    background-color: #fff;
    border-color: none;
    padding: 0 10px;
    position: relative;

    .el-icon-close {
      margin-left: 6px;
    }



    &::after {
      width: 0;
      /* 初始宽度为0 */
      display: block;
      content: "";
      height: 2px;
      // height: 4px;
      background-color: #007AFB;
      position: absolute;
      top: 0;
      left: 50%;
      /* 从中间开始 */
      transform: translateX(-50%);
      /* 居中定位 */
      z-index: 1;
      transition: width 0.3s ease-in-out;
    }

    &:hover {
      background-color: #efefef;
    }

    // 新增悬停效果
    &:hover::after {
      // width: 30%;
      width: 100%;
      /* 悬停时扩展到100%宽度 */
    }

  }

  .act-tag {
    position: relative;
    color: #007AFB;

    // &::after {
    //   // width: 30%;
    //   width: 100%;
    //   /* 扩展到100%宽度 */
    // }
    .cir {
      background-color: #007AFB;
    }

    &::before {
      background-color: #007AFB;
    }

  }

  .el-icon-close {
    &:hover {
      color: #007AFB;
    }
  }

  .tabs-container::-webkit-scrollbar {
    display: none;
  }

  .content {
    flex: 0 0 auto;
    /* 防止内容换行 */
    padding: 10px;
  }

  .box-shadow {
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs.vue